if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.reviews').slick({
        fade:true,
        accessibility: false,
        arrows:false,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                dots: true,
                adaptiveHeight:true
              }
            }
        ]
    })
    $( ".slick-prev" ).html(( "Prev" ));
    
    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
    });

    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });

    $('.js-review-prev').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.reviews');
        $curSlider.slick('slickPrev');
    });

    $('.js-review-next').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.reviews');
        $curSlider.slick('slickNext');
    });

    let bookingButtomDesktop = document.querySelector('.header__container .booking-menu');
    let bookingButtomMobile = document.querySelector('.bottom-nav .btn-botton-nav');

    document.querySelector('.header__container .booking-menu .btn.header__reserve').addEventListener('click',(e)=>{
        e.preventDefault();
    })
    bookingButtomDesktop.addEventListener('mouseover',(e)=>{
        e.preventDefault();
        bookingButtomDesktop.classList.add('active');
    })
    bookingButtomDesktop.addEventListener('mouseout',(e)=>{
        e.preventDefault();
        bookingButtomDesktop.classList.remove('active');
    })
    bookingButtomMobile.addEventListener('click',(e)=>{
        e.preventDefault();
        bookingButtomMobile.parentNode.classList.toggle('active');
    })
})();